import React, { Component } from 'react';
import Modal from 'react-modal';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import CBMediaQuery from '../../shared/CBMediaQuery';
import '../../../App.css';
import { getStyle, getModalStyle, SERVICE_CHAIN, SERVICE_WORKSHOP, SERVICE_FLEET, canResolveApprovalMessage } from '../../../utils/utils';
import CBButtonSubmit from '../../shared/CBButtonSubmit';
import CBInputField from '../../shared/form_components/CBInputField';
import CBTextAreaField from '../../shared/form_components/CBTextAreaField';
import CBSelectField from '../../shared/form_components/CBSelectField';
import RadioButtonGroup from '../../shared/RadioButtonGroup';
import {
  createVehicleMessageResponse as _createVehicleMessageResponse,
  updateVehicleMessageResponse as _updateVehicleMessageResponse,
} from '../../../actions/vehicleActions';
import {
  createMessageResponse as _createMessageResponse,
  approveMessage as _approveMessage,
  rejectMessage as _rejectMessage,
} from '../../../actions/messageActions';
import {
  getNumberValidator,
  getLengthValidator,
} from '../../../utils/validators';
import CBDatePickerInput from '../../shared/CBDatePickerInput';
import MessageCard from './MessageCard';
import CBModal from '../../shared/CBModal';
import CBDropzone from '../../shared/CBDropzone';
import ImagePreview from '../../shared/ImagePreview';


class AddMessageResponseModal extends Component {
  constructor(props) {
    super(props);

    const { response, presetDecision } = props;

    this.state = {
      showAllResponses: false,
      // '' = a plain reply. 'approved' / 'rejected' = decide the pending request
      // with the text as the comment or reason, so answering and deciding are
      // one step instead of a reply plus a separate menu action.
      decision: presetDecision || '',
      formData: {
        user: response ? response.user : undefined,
        text: response ? response.text : '',
        message: '',
        images: response ? response.images : [],
        image_actions: [],
      },
      formValid: {
        text: !!response,
      },
    };
  }

  componentDidMount = () => {
    const { user, message, response } = this.props;
    const { formData } = this.state;
    this.setState({
      formData: {
        ...formData,
        user: response
          ? response.user
          : user.id,
        message: message.id,
      },
    });
  };

  setIsValid = (name, isValid) => {
    const { formValid } = this.state;
    const newFormValid = {
      ...formValid,
      [name]: isValid,
    };

    this.setState({ formValid: newFormValid });
  };

  // Whether this reader may decide the request from here (pending, and this
  // portal is the one that decides). Editing an existing reply never decides.
  canDecide = () => {
    const { message, service, response } = this.props;
    return !response && canResolveApprovalMessage(message, service);
  };

  getIsValid = () => {
    const { formValid, decision } = this.state;
    if (decision && this.canDecide()) {
      // A decision needs no text; the comment is optional.
      return true;
    }
    let isValid = true;
    Object.values(formValid).forEach(fieldIsValid => {
      if (!fieldIsValid) {
        isValid = false;
      }
    });
    return isValid;
  };

  updateFormState = changedObject => {
    const { formData } = this.state;
    const newFormData = Object.assign({}, formData);
    newFormData[changedObject.target] = changedObject.value;
    this.setState({ formData: newFormData });
  };

  submitForm = () => {
    const { formData, decision } = this.state;
    const {
      createVehicleMessageResponse,
      updateVehicleMessageResponse,
      createMessageResponse,
      approveMessage,
      rejectMessage,
      response,
      closeModal,
      user,
      message,
      service,
      selectedWorkshopId,
      selectedChainId,
      selectedOrganizationId,
      isListRequest
    } = this.props;

    if (decision && this.canDecide()) {
      // The decision itself is recorded as a system response in the thread
      // ("Lupapyyntö hyväksytty. Kommentti: ..."), and mailed to the requester.
      const decisionChainId = message.chain_id || selectedChainId;
      const comment = (formData.text || '').trim();
      if (decision === 'approved') {
        approveMessage(message.id, decisionChainId, comment);
      } else {
        rejectMessage(message.id, decisionChainId, comment);
      }
      closeModal();
      return;
    }

    const wsId = service === SERVICE_WORKSHOP && selectedWorkshopId;
    // Use message's chain_id for chain messages (works across all portals), fall back to selected chain
    const chainId = (message && message.chain_id) || (service === SERVICE_CHAIN && selectedChainId);
    const orgId = !wsId && !chainId && service === SERVICE_FLEET && selectedOrganizationId;

    if (response) {
      updateVehicleMessageResponse(response.id, formData, wsId, chainId);
    } else {
      isListRequest
        ? createMessageResponse(formData, wsId, chainId, orgId)
        : createVehicleMessageResponse(formData, wsId, chainId, orgId);
    }
    this.setState({
      formData: {
        user: response
          ? response.name
          : `${user.profile.first_name} ${user.profile.last_name}`,
        text: response ? response.text : '',
        message: message.id,
      },
      formValid: {
        description: !!response,
      },
    });
    closeModal();
  };

  onDropImage = (acceptedFiles) => {
    acceptedFiles.forEach((file) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.imageChanged(reader.result, file);
      };
    });
  };

  imageChanged = (image, file) => {
    const { formData } = this.state;
    const newFormData = Object.assign({}, formData);
    newFormData.image_actions.push(
      {
        action: 'create',
        data: image,
        preview: file.preview,
      },
    );
    this.setState({ formData: newFormData });
  };

  deleteImage = (image) => {
    const { formData } = this.state;
    const newFormData = Object.assign({}, formData);
    // Is newly added image, not yet saved to backend
    if (image.preview) {
      newFormData.image_actions = newFormData.image_actions.filter(
        (img) => img.preview !== image.preview,
      );
    } else {
      newFormData.image_actions.push(
        {
          action: 'delete',
          id: image.id,
        },
      );
      newFormData.images = newFormData.images.filter(
        (img) => img.id !== image.id,
      );
    }
    this.setState({ formData: newFormData });
  };

  render() {
    const { formData, showAllResponses, decision } = this.state;
    const {
      modalIsOpen,
      closeModal,
      afterOpenModal,
      t,
      response,
      user,
      message,
      overlayZIndex,
    } = this.props;

    const newImages = formData.image_actions.filter((ia) => ia.action === 'create');
    const canDecide = this.canDecide();
    const decisionOptions = [
      { label: t('responseDecisionNone'), value: 'none' },
      { label: t('responseDecisionApprove'), value: 'approved' },
      { label: t('responseDecisionReject'), value: 'rejected' },
    ];
    let submitText = t('addMessageSaveButton');
    if (decision === 'approved') {
      submitText = t('responseDecisionApprove');
    } else if (decision === 'rejected') {
      submitText = t('responseDecisionReject');
    }

    return (
      <CBMediaQuery>
        {screenSize => (
          <CBModal
            modalIsOpen={modalIsOpen}
            afterOpenModal={afterOpenModal}
            closeModal={closeModal}
            overlayZIndex={overlayZIndex}
            contentLabel='Add response modal'
            isValid={this.getIsValid()}
            submitForm={this.submitForm}
            submitText={submitText}
            cancelText={t('cancel')}
            title={response ? t('updateMessageResponseLabel') : t('addNewResponse')}
            descriptionText={t('sendMessageDescription')}
            vehicleText={message.vehicle_registration_number}
          >
            <div style={getStyle(screenSize, styles, 'container')}>
              <div style={getStyle(screenSize, styles, 'previousMessagesContainer')}>
                {
                  !showAllResponses && message.responses.length > 1 && (
                    <button
                      className='opacity-on-hover'
                      style={getStyle(screenSize, styles, 'showAllButton')}
                      onClick={() => {this.setState({showAllResponses: true})}}
                    >
                      {t('showFullThread', { count: message.responses.length + 1 })}
                    </button>
                  )
                }

                <div style={getStyle(screenSize, styles, 'previousMessageContainer')}>
                  <MessageCard message={message} />
                </div>

                {
                  showAllResponses && (
                    message.responses.map((res, i, responses) => (
                      <MessageCard key={res.id} message={res} isLastResponse={i + 1 === responses.length} />
                    ))
                  )
                }
                {
                  !showAllResponses && message.responses.length > 0 && (
                    <MessageCard
                      message={message.responses[message.responses.length - 1]}
                      isLastResponse
                    />
                  )
                }
              </div>
              <div style={getStyle(screenSize, styles, 'bodyContainer')}>
                {canDecide && (
                  <div style={getStyle(screenSize, styles, 'decisionContainer')}>
                    <RadioButtonGroup
                      name='response_decision'
                      title={t('responseDecisionTitle')}
                      options={decisionOptions}
                      value={decision || 'none'}
                      setValue={(value) => this.setState({ decision: value === 'none' ? '' : value })}
                    />
                    {decision && (
                      <p style={getStyle(screenSize, styles, 'decisionHelp')}>
                        {t('responseDecisionHelp')}
                      </p>
                    )}
                  </div>
                )}
                <div style={getStyle(screenSize, styles, 'inputContainer')}>
                  <CBTextAreaField
                    name='text'
                    value={formData.text}
                    onChange={this.updateFormState}
                    labelText={decision ? t('responseDecisionCommentLabel') : t('addMessageTextLabel')}
                    labelTextStyle={getStyle(screenSize, styles, 'subTitle')}
                    validators={[getLengthValidator(1, 5000)]}
                    isValidCallback={this.setIsValid}
                    validateOnInput
                  />
                </div>
                {!decision && (
                  <div style={getStyle(screenSize, styles, 'dropZoneContainer')}>
                    <CBDropzone
                      className='opacity-on-hover'
                      onDropAccepted={this.onDropImage}
                    >
                      <p style={getStyle(screenSize, styles, 'dropZoneText')}>
                        {t('addImages')}
                      </p>
                    </CBDropzone>
                  </div>
                )}
                <div style={getStyle(screenSize, styles, 'imagesContainer')}>
                  {
                    !!formData.images.length && (
                      formData.images.map((image) => (
                        <ImagePreview
                          src={image.thumbnail}
                          onDelete={() => this.deleteImage(image)}
                        />
                      ))
                    )
                  }
                  {
                    !!newImages.length && (
                      newImages.map((image) => (
                        <ImagePreview
                          src={image.preview}
                          onDelete={() => this.deleteImage(image)}
                        />
                      ))
                    )
                  }
                </div>
              </div>
            </div>
          </CBModal>
        )}
      </CBMediaQuery>
    );
  }
}

const styles = {
  default: {
    bodyContainer: {
      padding: 32,
      width: '100%',
    },
    inputContainer: {
      marginBottom: 32,
    },
    decisionContainer: {
      marginBottom: 16,
      padding: '4px 12px',
      backgroundColor: '#eaf3f8',
      borderLeft: '3px solid #0077b6',
      borderRadius: 4,
    },
    decisionHelp: {
      fontSize: 13,
      color: '#1b3a4b',
      textAlign: 'center',
      margin: '0 0 8px 0',
    },
    imagesContainer: {
      marginTop: 16,
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'center',
    },
    dropZoneContainer: {
    },
    dropZoneText: {
      color: 'rgb(102, 102, 102)',
      fontSize: 24,
    },
    showAllButton: {
      height: 48,
      backgroundColor: '#FFFFFF',
      borderRadius: 8,
      boxShadow: 0,
      marginBottom: 16,
      opacity: '70%',
      border: '1px solid rgba(0, 0, 0, 0.5)',
    },
    container: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      width: '100%',
    },
    previousMessagesContainer: {
      minHeight: 200,
      backgroundColor: 'rgba(243, 243, 253, 1)',
      display: 'flex',
      flexDirection: 'column',
      padding: 32,
    },
    previousMessageContainer: {
      display: 'flex',
      justifyContent: 'flex-end',
    },
    subTitle: {
      fontSize: 14,
      color: 'black',
      textAlign: 'center',
      fontWeight: 600,
    },
  },
  small: {
    bodyContainer: {
      display: 'flex',
      flexDirection: 'column',
      padding: '16px 16px'
    },
    previousMessagesContainer: {
      minHeight: 200,
      backgroundColor: 'rgba(243, 243, 253, 1)',
      display: 'flex',
      flexDirection: 'column',
      padding: 16,
    },
  },
};

function mapStateToProps(state) {
  return {
    user: state.authUser.user,
    service: state.app.service,
    selectedWorkshopId: state.workshop.selectedWorkshop,
    selectedChainId: state.chain.selectedChainId,
    selectedOrganizationId: state.organization.selectedOrganization,
  };
}

export default connect(
  mapStateToProps,
  {
    createVehicleMessageResponse: _createVehicleMessageResponse,
    updateVehicleMessageResponse: _updateVehicleMessageResponse,
    createMessageResponse: _createMessageResponse,
    approveMessage: _approveMessage,
    rejectMessage: _rejectMessage,
  },
)(translate('VehicleDetailsView')(AddMessageResponseModal));
